import FastMarquee from "react-fast-marquee";
import { Star } from "lucide-react";

const words = [
  "Procurement",
  "Interior Design",
  "Supply Solutions",
  "Project Execution",
  "Business Support",
  "GeM Registered",
];

export default function Marquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="relative bg-[var(--nv-navy)] text-[var(--nv-paper)] border-y border-[var(--nv-line-dark)]"
    >
      <FastMarquee speed={38} gradient={false} pauseOnHover className="py-8 md:py-10">
        {words.concat(words).map((w, i) => (
          <span key={i} className="flex items-center gap-8 md:gap-14 pr-8 md:pr-14">
            <span className="font-serif italic text-4xl md:text-6xl lg:text-7xl leading-none whitespace-nowrap">
              {w}
            </span>
            <Star className="w-5 h-5 md:w-6 md:h-6 text-[var(--nv-gold)]" />
          </span>
        ))}
      </FastMarquee>
    </section>
  );
}
